// extracted by mini-css-extract-plugin
export default {"input":"style-module__input___sUNnD"};
    if(module.hot) {
      // 1697460475906
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  